export const SUCCESS_HOTEL_RECOMMENDATION_BANNER_KEY = 'rsvpsuccesshotelrecommendation';
